<template>
  <Modal
    :value="modalCancelNfseIsOpen"
    :onClose="toggleModalCancelNfseId"
    size="small"
  >
    <b-row>
      <b-col class="mb-3">
        <SelectNfseCancellationType
          :clearable="false"
          :error="$v.cancellationType.$error"
          v-model="cancellationType"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <Label>Justificativa:</Label>
      </b-col>
    </b-row>
    <b-row align="center">
      <b-col md="12" class="mb-3">
        <TextField
          class="input"
          :error="$v.cancellationReason.$error"
          v-model="cancellationReason"
        />
      </b-col>
    </b-row>
    <b-row align="center">
      <b-col>
        <Button type="cancel" @click="toggleModalCancelNfseId()">
          <Close class="mb-1" title="Cancelar" /> Cancelar
        </Button>
        <Button @click="handleCancel()" type="success">Confirmar</Button>
      </b-col>
    </b-row>
  </Modal>
</template>

<script>
import Close from 'vue-material-design-icons/Close';
import { Button, TextField } from '@/components/Form';
import { mapActions, mapState } from 'vuex';
import { Modal, Label, SelectNfseCancellationType } from '@/components';
import { required } from '@/reusable/validations';

export default {
  name: 'ModalCancelNFSe',
  components: {
    Modal,
    Button,
    Close,
    Label,
    TextField,
    SelectNfseCancellationType,
  },
  validations: {
    cancellationType: { required },
    cancellationReason: { required },
  },
  data() {
    return {
      cancellationType: null,
      cancellationReason: null,
    };
  },
  computed: {
    ...mapState('nfseComponents', [
      'modalCancelNfseIsOpen',
      'modalCancelNfseId',
    ]),
  },
  methods: {
    ...mapActions('nfse', ['cancelNfse']),
    ...mapActions('application', ['setLoading']),
    ...mapActions('nfseComponents', ['toggleModalCancelNfseId']),

    isValidFields() {
      this.$v.$touch();

      if (!this.$v?.$error) return true;
      return false;
    },
    async handleCancel() {
      if (!this.isValidFields()) return;

      await this.cancelNfse({
        id: this.modalCancelNfseId,
        cancellationType: this.cancellationType.id,
        cancellationReason: this.cancellationReason,
      });
      this.toggleModalCancelNfseId();
    },
  },
  watch: {
    modalCancelNfseIsOpen() {
      if (!this.modalCancelNfseIsOpen) {
        this.cancellationReason = null;
      }
    },
  },
};
</script>
